<script>
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/ButtonElement.vue";
import TextOption from "%/dynamic-component-editor/options/text-option";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";
import ActionTrigger from "%/dynamic-component-editor/options/action-trigger";
import StopPropagation from "%/dynamic-component-editor/options/stop-propagation";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import { camelToTitleCase } from "@bloglovin/vue-framework";
import resolveVisibleOption from "%/dynamic-component-editor/helpers/resolve-visible-option";
import Visible from "%/dynamic-component-editor/options/visible";
import { isVisibleOnWeb } from "%/dynamic-component-editor/helpers/visibility-surface";

export default {
  name: "DynamicAppButtonElement",
  elementPanelSettings: {
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  extends: ButtonElement,
  mixins: [DynamicElementWithContext],
  options: [ContextBindings, ActionTrigger, StopPropagation],
  hidden: true,
  computed: {
    firesWhenShown() {
      return this.getOptionValue(ActionTrigger) === ActionTrigger.WHEN_SHOWN;
    },
    shouldRenderButton() {
      return this.editMode || !this.firesWhenShown;
    },
    isShownToFire() {
      return !this.editMode && this.firesWhenShown
        && isVisibleOnWeb(resolveVisibleOption(this.getOptionValue(Visible), this));
    },
    textOptionValue() {
      if (this.elementContext?.field) {
        const bound = this.valueFromContext;
        if (bound !== null && bound !== undefined && bound !== "") {
          return { body_text: String(bound), ranges: [] };
        }
      }
      const setValue = this.getOptionValue(TextOption) || "";
      const body = typeof setValue === "string" ? setValue : setValue?.body_text;
      if (body && body !== "\n") {
        return setValue;
      }
      if (this.getOptionValue(IconPosition) === "noText") {
        return setValue;
      }
      const actionName = this.elementContext?.actionName;
      if (!actionName) {
        return setValue;
      }
      return { body_text: camelToTitleCase(actionName), ranges: [] };
    },
  },
  watch: {
    isShownToFire: {
      immediate: true,
      handler(shown) {
        if (shown) {
          this.triggerNamedAction(this.elementContext?.actionName);
        }
      },
    },
  },
  methods: {
    handleButtonClick(e) {
      this.executeAction(e);
    },
  },
};
</script>
